import { render, staticRenderFns } from "./ProviderReport.vue?vue&type=template&id=ecdc873a&scoped=true&"
import script from "./ProviderReport.vue?vue&type=script&lang=ts&"
export * from "./ProviderReport.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderReport.vue?vue&type=style&index=0&id=ecdc873a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdc873a",
  null
  
)

export default component.exports